import React from 'react'
import { DigitalVaultCategoriesAction, DigitalVaultCompaniesAction, DigitalVaultSubcategoriesAction, DigitalVaultDocumentAction } from '../../actions'
import './digital-vault-home.css'

const DigitalVaultHomeView = (props) => {
    if (props.selectedDocument) {
        return (
            <DigitalVaultDocumentAction
                {...props}
                id={props.selectedDocument.id}
                isFromDigitalVault={true}
                goBack={() => props.setSelectedDocument(null)}
                stateToMaintain={{
                    selectedCompany: props.selectedCompany,
                    selectedCategory: props.selectedCategory,
                    subcategoryPath: props.subcategoryPath,
                    selectedDocument: props.selectedDocument
                }}
            />
        )
    } else if (props.selectedCategory) {
        return <DigitalVaultSubcategoriesAction {...props} />
    } else if (props.selectedCompany) {
        return <DigitalVaultCategoriesAction {...props} />
    } else {
        return <DigitalVaultCompaniesAction {...props} />
    }
}

export default DigitalVaultHomeView